// extracted by mini-css-extract-plugin
export default {"option":"styles_option__kihep","optionActive":"styles_optionActive__qn0zm"};